<template>
  <div
    tabindex="0"
    class="tree-select-dropdown no-focus-visible"
    @keydown.stop="$emit('handle-click-navigation', $event)"
  >
    <SpinnerContainer
      :is-loading="isLoading"
      class="tree-select-dropdown__list"
    >
      <div class="tree-select-list">
        <TreeSelectDropdownTree
          v-show="!isLoading"
          :readonly="readonly"
          :tree-is-loading="treeIsLoading"
          class="tree-select-list__tree"
          :flat-choices="flatChoices"
          :selected-items="selectedItems"
          :search-text="searchText"
          :no-child-text-getter="noChildTextGetter"
          :is-leaf-node-predicate="isLeafNodePredicate"
          @searchTextInput="$emit('searchTextInput', $event)"
          @triggerCheckbox="handleTriggerNode"
          @handle-click-navigation="$emit('handle-click-navigation', $event)"
        />
        <TreeSelectDropdownSelected
          :readonly="readonly"
          :flat-choices="flatChoices"
          :selected-items="selectedItems"
          :nodes-parent-map="nodesParentMap"
          :selected-items-text="selectedItemsText"
          :leaf-nodes="leafNodes"
          @removeItem="$emit('removeNode', $event)"
          @resetAll="$emit('resetAll')"
        />
      </div>
    </SpinnerContainer>
    <TreeSelectDropdownControls
      :disable-ok-button="disableOkButton"
      :readonly="readonly"
      class="tree-select-dropdown__controls"
      @cancel="$emit('cancel')"
      @submit="$emit('submit')"
    />
  </div>
</template>

<script>
  import TreeSelectDropdownTree from 'components/Inputs/Select/TreeSelect/TreeSelectDropdownTree';
  import TreeSelectDropdownSelected from 'components/Inputs/Select/TreeSelect/TreeSelectDropdownSelected';
  import TreeSelectDropdownControls from 'components/Inputs/Select/TreeSelect/TreeSelectDropdownControls';
  import SpinnerContainer from 'components/Loaders/SpinnerContainer';
  import _ from 'lodash';

  _.noConflict();

  export default {
    name: 'TreeSelectDropdown',
    components: {SpinnerContainer, TreeSelectDropdownControls, TreeSelectDropdownSelected, TreeSelectDropdownTree},
    props: {
      isLoading: {
        type: Boolean,
        default: false
      },
      flatChoices: {
        type: Object,
        default: Object
      },
      selectedItems: {
        type: Array,
        default: Array
      },
      nodesParentMap: {
        type: Object,
        default: Object
      },
      selectedItemsText: {
        type: String,
        default: ''
      },
      searchText: {
        type: String,
        default: ''
      },
      treeIsLoading: {
        type: Boolean,
        default: false
      },
      leafNodes: {
        type: Array,
        default: Array
      },
      readonly: {
        type: Boolean,
        default: false
      },
      disableOkButton: {
        type: Object,
        default: Object
      },
      noChildTextGetter: {
        type: Function,
        required: true
      },
      isLeafNodePredicate: {
        type: Function,
        default: undefined
      }
    },
    methods: {
      handleTriggerNode (nodeId) {
        if (this.selectedItems.find(i => i === nodeId)){
          this.$emit('removeNode', nodeId);
          return;
        }
        this.$emit('addNode', nodeId);
      }
    }
  };
</script>

<style>
  .tree-select-dropdown {
    display: flex;

    flex-direction: column;

    height: 100%;
  }

  .tree-select-list {
    display: flex;
    height: 340px;
  }

  .tree-select-list > * {
    flex-grow: 0;
    flex-shrink: 0;
  }

  .tree-select-list__tree {
    border-right: 1px solid var(--border-color);
  }

  .tree-select-dropdown__controls {
    flex-grow: 0;
    flex-shrink: 0;

    height: 46px;

    border-top: 1px solid var(--border-color);
  }
</style>
